export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "notifications": {
          "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Notifications"])},
          "settingsTooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Configure notifications"])},
          "read": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Read"])},
          "markAllRead": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mark all as read"])}
        },
        "tabs": {
          "all": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["All"])},
          "tasks": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tasks"])},
          "payments": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Payments"])}
        }
      },
      "ru": {
        "notifications": {
          "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Уведомления"])},
          "settingsTooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Настроить уведомления"])},
          "read": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Прочитанные"])},
          "markAllRead": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Отметить все как прочитанные"])}
        },
        "tabs": {
          "all": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Все"])},
          "tasks": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Задания"])},
          "payments": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Оплаты"])}
        }
      },
      "es": {
        "notifications": {
          "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Notificaciones"])},
          "settingsTooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Configurar notificaciones"])},
          "read": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Leídas"])},
          "markAllRead": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Marcar todas como leídas"])}
        },
        "tabs": {
          "all": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Todas"])},
          "tasks": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tareas"])},
          "payments": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pagos"])}
        }
      },
      "kk": {
        "notifications": {
          "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Хабарламалар"])},
          "settingsTooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Хабарламаларды баптау"])},
          "read": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Оқылған"])},
          "markAllRead": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Барлығын оқылған деп белгілеу"])}
        },
        "tabs": {
          "all": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Барлығы"])},
          "tasks": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Тапсырмалар"])},
          "payments": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Төлемдер"])}
        }
      },
      "uz": {
        "notifications": {
          "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bildirişlar"])},
          "settingsTooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bildirişlarni sozlash"])},
          "read": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["O'qilgan"])},
          "markAllRead": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hammasini o'qilgan deb belgilash"])}
        },
        "tabs": {
          "all": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Barchasi"])},
          "tasks": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vazifalar"])},
          "payments": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["To'lovlar"])}
        }
      },
      "de": {
        "notifications": {
          "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Benachrichtigungen"])},
          "settingsTooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Benachrichtigungen konfigurieren"])},
          "read": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gelesen"])},
          "markAllRead": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Alle als gelesen markieren"])}
        },
        "tabs": {
          "all": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Alle"])},
          "tasks": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aufgaben"])},
          "payments": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zahlungen"])}
        }
      },
      "fr": {
        "notifications": {
          "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Notifications"])},
          "settingsTooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Configurer les notifications"])},
          "read": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lu"])},
          "markAllRead": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Marquer tout comme lu"])}
        },
        "tabs": {
          "all": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tous"])},
          "tasks": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tâches"])},
          "payments": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paiements"])}
        }
      },
      "it": {
        "notifications": {
          "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Notifiche"])},
          "settingsTooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Imposta notifiche"])},
          "read": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Letti"])},
          "markAllRead": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Segna tutto come letto"])}
        },
        "tabs": {
          "all": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tutti"])},
          "tasks": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Compiti"])},
          "payments": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pagamenti"])}
        }
      }
    }
  })
}
